import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler;

/** Dispatches a clear of all Dynamic Form field values. */
export const DispatchClearForm: HandlerType = props => {
    props.dispatch({
        type: "Components/DynamicForm/ClearForm",
    });
};

export const chain = [DispatchClearForm];

const clearDynamicForm = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearDynamicForm");
export default clearDynamicForm;
